import { cn } from '@/lib/utils';
import type { MouseEvent } from 'react';

/** `id` of the main region of every page (the `mainId` of the shell): the target of the skip link and of the focus on a new page. */
export const ID_CONTENU = 'contenu';

interface LienEvitementProps {
  /** Distance from the left edge of the window, to clear the navbar when there is one. */
  className?: string;
}

/**
 * The skip link of the login page (S14, #5): the first thing a Tab reaches, shown only while it
 * has the focus, and it leads to the main region. The connected pages have the one of the
 * `AppShell` of the design system; this one is dressed the same (white, bleu nuit text, shadow,
 * at the top left) so that every page of the app starts the same way for the keyboard.
 *
 * The click is handled here rather than left to the browser: the router owns the URL, and an
 * anchor to `#contenu` would add a fragment to it for nothing.
 */
export function LienEvitement({ className }: LienEvitementProps) {
  function aller(evenement: MouseEvent<HTMLAnchorElement>) {
    const contenu = document.getElementById(ID_CONTENU);
    if (contenu === null) return;
    evenement.preventDefault();
    contenu.focus();
  }

  return (
    <a
      href={`#${ID_CONTENU}`}
      onClick={aller}
      className={cn(
        'sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:font-semibold focus:text-bleu-nuit focus:no-underline focus:shadow-md focus:hover:text-bleu-nuit',
        className,
      )}
    >
      aller au contenu
    </a>
  );
}
